<div class="w-full h-full">
  <stch-top-progress-bar />
  <router-outlet />
  <app-held-stitch-tray />
  <app-product-analytics-consent />
  <ng-template appModalHost />
</div>
